"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactSelect = _interopRequireDefault(require("react-select"));
var _helpers = require("../../helpers");
var _WebRequestHelper = require("../../helpers/WebRequestHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const formatOptionLabel = (option, entity, isMulti) => {
  if (isMulti) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "badge badge-pill badge-primary"
    }, /*#__PURE__*/_react.default.createElement("span", null, entity.getDisplayName ? entity.getDisplayName(option) : option[entity.displayName]));
  } else if (!isMulti && entity.foreign === "License") {
    if (entity.getDisplayName && option.RemainingUserLicenses >= 0 && option.UserLicenseQuota) {
      return /*#__PURE__*/_react.default.createElement("span", null, `${entity.getDisplayName(option)} (${option.RemainingUserLicenses} left out of ${option.UserLicenseQuota})`);
    }
  } else if (!isMulti && option.Level) {
    switch (option.Level) {
      case 2:
        {
          return /*#__PURE__*/_react.default.createElement("span", {
            style: {
              marginLeft: "1.5rem"
            }
          }, entity.getDisplayName ? entity.getDisplayName(option) : option[entity.displayName]);
        }
      case 3:
        {
          return /*#__PURE__*/_react.default.createElement("span", {
            style: {
              marginLeft: "3rem"
            }
          }, entity.getDisplayName ? entity.getDisplayName(option) : option[entity.displayName]);
        }
      case 4:
        {
          return /*#__PURE__*/_react.default.createElement("span", {
            style: {
              marginLeft: "4.5rem"
            }
          }, entity.getDisplayName ? entity.getDisplayName(option) : option[entity.displayName]);
        }
      case option.Level >= 5:
        {
          return /*#__PURE__*/_react.default.createElement("span", {
            style: {
              marginLeft: "6rem"
            }
          }, entity.getDisplayName ? entity.getDisplayName(option) : option[entity.displayName]);
        }
    }
  }
  return /*#__PURE__*/_react.default.createElement("span", null, entity.getDisplayName ? entity.getDisplayName(option) : option[entity.displayName]);
};
class EntitySearch extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "state", {
      value: "",
      search: "",
      data: [],
      fetching: false,
      fetched: false
    });
    _defineProperty(this, "handleChange", (value, {
      action
    }) => {
      switch (action) {
        case "input-change":
          this.setState({
            value
          });
          return;
        default:
          return;
      }
    });
    _defineProperty(this, "createTreefromList", (dataset, parentName = "ParentCategoryId") => {
      function removeBranchFromTree(dataTree, id) {
        if (!dataTree) return false;
        return dataTree.reduce((acc, child) => {
          if (child["Id"] === id) {
            const removedChild = removeBranchFromTree(child["ChildNodes"], id);
          } else {
            child.ChildNodes = removeBranchFromTree(child["ChildNodes"], id);
            acc.push(child);
          }
          return acc;
        }, []);
      }
      let currentElement = this.props.elementBeingEdited;
      let hashTable = Object.create(null);
      dataset.forEach(aData => hashTable[aData.Id] = {
        ...aData,
        ChildNodes: []
      });
      let dataTree = [];
      dataset.forEach(aData => {
        if (aData[parentName]) hashTable[aData[parentName]].ChildNodes.push(hashTable[aData.Id]);else dataTree.push(hashTable[aData.Id]);
      });
      if (currentElement) dataTree = removeBranchFromTree(dataTree, currentElement.Id);
      return dataTree;
    });
    _defineProperty(this, "flattenTree", (treeObj, idAttr = "Id", parentAttr = "ParentCategoryId", childrenAttr = "ChildNodes", levelAttr = "Level") => {
      function processChildren(obj, level = 0) {
        let array = [];
        Object.values(obj[childrenAttr]).forEach(function (childObj) {
          array = array.concat(flattenChild(childObj, level + 1));
        });
        return array;
      }
      function flattenChild(childObj, level) {
        let array = [];
        let childCopy = Object.assign({}, childObj);
        childCopy[levelAttr] = level;
        delete childCopy[childrenAttr];
        array.push(childCopy);
        array = array.concat(processChildren(childObj, level));
        return array;
      }
      let keys = Object.keys(treeObj[0]);
      let parentNode = {};
      let result;
      for (let i = 0; i < keys.length; i++) {
        if (keys[i] === childrenAttr) parentNode[keys[i]] = {
          ...treeObj
        };else if (keys[i] === idAttr) parentNode[keys[i]] = "0";else parentNode[keys[i]] = "";
      }
      result = processChildren(parentNode);
      return result;
    });
    _defineProperty(this, "get", (string, useAuthentication = true) => {
      const {
        entity
      } = this.props;
      const filter = entity.filterString(string);
      const url = entity.foreign.charAt(entity.foreign.length - 1).toLowerCase() === "y" ? `${entity.foreign.slice(0, -1)}ies`.toLowerCase() : `${entity.foreign}s`.toLowerCase();
      const params = (0, _helpers.paramsToString)({
        filter: encodeURI(filter),
        limit: entity.limit
      });
      this.setState({
        fetching: true
      });
      return (0, _WebRequestHelper.createRequest)(useAuthentication).then(request => {
        request.method = "get";
        request.url = `${url}${params}`;
        return (0, _WebRequestHelper.sendRequest)(request).then(response => {
          if (entity.displayName === "Parent") {
            // Custom option, just for "Parent Category" in ViShow project.

            let tree = this.createTreefromList(response.data);
            let flattenedTree;
            flattenedTree = this.flattenTree(tree, "ParentCategoryId");
            this.setState({
              data: flattenedTree,
              fetching: false
            });
          } else {
            this.setState({
              data: response.data,
              fetching: false
            });
          }
        }).catch(() => {
          this.setState({
            fetching: false
          });
        });
      }).catch(err => console.dir(err));
    });
    _defineProperty(this, "render", () => {
      const {
        entity,
        onChange,
        isMulti = true,
        value,
        defaultValue,
        elementBeingEdited
      } = this.props;
      const {
        data,
        fetching
      } = this.state;
      if (entity.foreign === "License" && !elementBeingEdited) {
        if (!data.length) return null;else return /*#__PURE__*/_react.default.createElement("div", {
          style: {
            minWidth: "12rem"
          }
        }, /*#__PURE__*/_react.default.createElement(_reactSelect.default, {
          className: "text-dark",
          options: data,
          isMulti: isMulti,
          isClearable: true,
          isLoading: fetching,
          onChange: onChange,
          onInputChange: this.handleChange,
          onSelectResetsInput: false,
          getOptionLabel: option => entity.getDisplayName ? entity.getDisplayName(option) : option[entity.displayName],
          getOptionValue: option => option["Id"],
          value: value,
          defaultValue: "Select an Option",
          formatOptionLabel: option => formatOptionLabel(option, entity, isMulti)
        }));
      }
      if (entity.foreign === "ARConfiguration" && !elementBeingEdited) {
        if (!data.length) return null;else {
          const selectedOption = data.find(option => option.Id === value);
          return /*#__PURE__*/_react.default.createElement("div", {
            style: {
              minWidth: "12rem"
            }
          }, /*#__PURE__*/_react.default.createElement(_reactSelect.default, {
            className: "text-dark",
            options: data,
            isMulti: false,
            isClearable: true,
            isLoading: fetching,
            onChange: onChange,
            onInputChange: this.handleChange,
            onSelectResetsInput: false,
            getOptionLabel: option => entity.getDisplayName ? entity.getDisplayName(option) : option[entity.displayName],
            getOptionValue: option => option["Id"],
            value: selectedOption || "",
            defaultValue: selectedOption || "",
            formatOptionLabel: option => formatOptionLabel(option, entity, isMulti)
          }));
        }
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          minWidth: "12rem"
        }
      }, /*#__PURE__*/_react.default.createElement(_reactSelect.default, {
        className: "text-dark",
        options: data,
        isMulti: isMulti,
        isClearable: true,
        isLoading: fetching,
        onChange: onChange,
        onInputChange: this.handleChange,
        onSelectResetsInput: false,
        getOptionLabel: option => entity.getDisplayName ? entity.getDisplayName(option) : option[entity.displayName],
        getOptionValue: option => option["Id"],
        value: value,
        defaultValue: defaultValue,
        formatOptionLabel: option => formatOptionLabel(option, entity, isMulti)
      }));
    });
    this.debouncedGet = (0, _helpers.debounce)(this.get, 100);
  }
  componentDidMount() {
    this.debouncedGet("");
  }
}
var _default = exports.default = EntitySearch;
module.exports = exports.default;